// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "resources/" + chunkId + "." + {"189":"397b974ee383c7f0839c","946":"08458739b24c221f87ce"}[chunkId] + ".js";
};